import BaseCacheEngine from'./BaseCacheEngine.js';class PlainLocalStorageDriver extends BaseCacheEngine {
    /**
     * Set the storage engine
     */
    storage = localStorage;
}export{PlainLocalStorageDriver as default};